export enum CtaVariantEnum {
  Link = 'link',
  Link2 = 'link-2',
  LinkDisruptive = 'link-disruptive',
  LinkImage = 'image',
}
